const fiatCapabilities = [
  'BENEFICIARIES_CUBIX',
  'BENEFICIARIES_ACH_FEDWIRE',
  'BENEFICIARIES_AED',
  'BENEFICIARIES_CRNOW',
  'BENEFICIARIES_RTP',
  'BENEFICIARIES_FEDNOW',
].map(name => ({
  group: 'FIAT',
  name,
}))

export const ACCOUNT_LEVEL_CAPABILITIES = [
  {
    group: 'ACCOUNT',
    name: 'PRINCIPLE_CUSTOMER_COMPANY',
  },
  {
    group: 'ACCOUNT',
    name: 'PRINCIPLE_CUSTOMER_INDIVIDUAL',
  },
  {
    group: 'ACCOUNT',
    name: 'EMBEDDED_CUSTOMER_COMPANY',
  },
  {
    group: 'ACCOUNT',
    name: 'EMBEDDED_CUSTOMER_INDIVIDUAL',
  },
  {
    group: 'NETWORK',
    name: 'PARTICIPANT',
  },
  {
    group: 'EPC',
    name: 'WALLET_ACTIONS',
  },
  {
    group: 'EPC',
    name: 'EMBEDDED_WALLET_CREATION',
  },
  ...fiatCapabilities,
]
